export default class TractChoroplethStyleConfig {
    constructor(){
        this.config = {
            h: {
                title: "<span class='text-h6'>Hispanic CVAP</span><br />",
                titleplaintext: "Hispanic CVAP",
                description: "Hispanic CVAP",
                scale:[ 
                    {
                        color:"#BAE3B3", 
                        step:[.25, false]
                    },
                    {
                        color:"#74C477", 
                        step:[.25,true,.5,false]
                    },
                    {
                        color:"#31A353",
                        step:[.5,true,.75,false]
                    },
                    {
                        color:"#006E2C",
                        step:[.75,true, 1, true]  
                    }
                ]
            },
            w: {
                title: "<span class='text-h6'>White Non-Hispanic CVAP</span><br />",
                titleplaintext: "White Non-Hispanic CVAP",
                description: "White Non-Hispanic CVAP",
                scale:[ 
                    {
                        color:"#BED8E8", 
                        step:[.25,false]
                    },
                    {
                        color:"#6BAFD6", 
                        step:[.25,true,.5,false]
                    },
                    {
                        color:"#3183BD",
                        step:[.5,true,.75,false]
                    },
                    {
                        color:"#08529C", 
                        step:[.75,true,1, true]  
                    }
                ]
            },
            b: {
                title: "<span class='text-h6'>Black CVAP</span><br />",
                titleplaintext: "Black CVAP",
                description: "Black CVAP",
                scale:[ 
                    {
                        color:"#FCBF86", 
                        step:[.25,false]
                    },
                    {
                        color:"#FC8D3D",
                        step:[.25,true,.5,false]
                    },
                    {
                        color:"#E6560E", 
                        step:[.5,true,.75,false]
                    },
                    {
                        color:"#A63703", 
                        step:[.75,true,1, true]  
                    }
                ]
            },
            as: {
                title: "<span class='text-h6'>Asian CVAP</span><br />",
                titleplaintext: "Asian CVAP",
                description: "Asian CVAP",
                scale:[ 
                    {
                        color:"#FAB4B9", 
                        step:[.25,false]
                    },
                    {
                        color:"#F768A1",
                        step:[.25,true,.5,false]
                    },
                    {
                        color:"#C41B89", 
                        step:[.5,true,.75,false]
                    },
                    {
                        color:"#7A0178", 
                        step:[.75,true,1, true]  
                    }
                ]
            },
            ai: {
                title: "<span class='text-h6'>American Indian / Alaska Native CVAP</span><br />",
                titleplaintext: "American Indian / Alaska Native CVAP",
                description: "American Indian / Alaska Native CVAP",
                scale:[ 

                    {
                        color:"#cbc9e2", 
                        step:[.25,false]
                    },
                    {
                        color:"#9e9ac8", 
                        step:[.25,true,.5,false]
                    },
                    {
                        color:"#756bb1",
                        step:[.5,true,.75,false]
                    },
                    {
                        color:"#54278f",
                        step:[.75,true,1, true]  
                    }
                ]
            }
            ,
            n: {
                title: "<span class='text-h6'>Native Hawaiian / Other Pacific Islander CVAP</span><br />",
                titleplaintext: "Native Hawaiian / Other Pacific Islander CVAP",
                description: "Native Hawaiian / Other Pacific Islander CVAP",
                scale:[ 

                    {
                        color:"#C9C9C9", //f46d43
                        step:[.25,false]
                    },
                    {
                        color:"#969696", //fdae61
                        step:[.25,true,.5,false]
                    },
                    {
                        color:"#636363", //fee090
                        step:[.5,true,.75,false]
                    },
                    {
                        color:"#363636", //4575b4
                        step:[.75,true,1, true] //need to shrink 
                    }
                ]
            }
        }
    }
}